module.exports = __webpack_public_path__ + "why4.webp?b3901a9be77e5189e8154f429f688b0a";